import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { BranchService } from '@app/_services/masters/branch.service';
import { branch } from '@app/_models/branch';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { LogService } from '../../../_shared/log.service'
import { VerifyDocumentService } from '@app/_services/verifyDocument.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-branch-master-add',
  templateUrl: './branch-master-add.component.html',
  styleUrls: ['./branch-master-add.component.css']
})
export class BranchMasterAddComponent implements OnInit {

  constructor(private eventService: LogService, private formBuilder: FormBuilder, private branchService: BranchService,
    private modalService: NgbModal, config: NgbModalConfig, private verifyDocService: VerifyDocumentService, private router: Router) { }

  branch = new branch();
  streamDropDown = [];
  streamId: number;
  branchForm: FormGroup;
  submitted = false;
  strMessage: string;
  getresponse: any;
  returnUrl;

  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;


  ngOnInit(): void {
    this.branchForm = this.formBuilder.group({
      branchname: ['', Validators.required],
      streamid: ['', Validators.required],
    });

    this.verifyDocService.getStreams()
    .pipe(first())
    .subscribe(
      data => {
        // console.log("streams response---", data.respData)
        this.streamDropDown = data.respData;
      },
      error => {
        console.log(error)
      }
    )
  }
  get f() { return this.branchForm.controls; }

  addBranch() {
    this.submitted = true;

    if (this.branchForm.invalid) {
      return;
    }
    this.branchService.addBranch(this.branch)
      .subscribe((response) => {
        if (response) {
          this.getresponse = response;
          if (this.getresponse.respMessage == "Success") {
            this.strMessage = "Branch Added Successfully.";
            this.modalService.open(this.showModalBoxTemplate);
            var v = response;
          }

          else if (this.getresponse.respMessage == "Failure") {
            this.strMessage = this.getresponse.respData;
            this.modalService.open(this.showModalBoxTemplate);
            var v = response;
          }
        }
      },
        (err: any) => {
          var message = err;
        });
  }

  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('20');
  }

  goBack() {
    this.eventService.emit<string>('20');
  }





}
